import Vue from 'vue'
import axios from 'axios'
import router from '@/router'
import {
  MessageBox,
  Message
} from 'element-ui'
import { Loading } from 'element-ui';
let loadingInstance;
// var vm = new Vue ({
//   router,
//   render:h=>h(App)
// }).$mount('#app')
axios.interceptors.request.use(config => {
  let tokenData = JSON.parse(window.sessionStorage.getItem('tokenData'));
  loadingInstance = Loading.service({
    lock: true,
    text: 'Loading',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.7)'
  });
  if (tokenData) {
    // 本地获取
    let token;
    token = tokenData.token;
    // if (process.env.NODE_ENV == 'development'||process.env.NODE_ENV == 'development1') {
    // }else{
    //   // 线上获取
    //   token = tokenData;
    // }
    config.headers.Authorization = 'Bearer ' + token;
  } else {

  }
  // if (config.url=='/Users/login') {
  // }else{
  //   let tokenData = JSON.parse(window.sessionStorage.getItem('tokenData'));
  //   let token = tokenData.token;
  //   config.headers.Authorization = 'Bearer' + token;
  //   config.headers.Authorization = 'Bearer'+'1111'
  // }
  return config
})
// 响应拦截
axios.interceptors.response.use(
  response => {
    // response.setHeader("Access-Control-Expose-Headers", "Content-Disposition")
    // response.setHeader("Content-Disposition", ...)
    // 请求成功
    // 1. 根据自己项目需求定制自己的拦截
    // 2. 然后返回数据
    // setTimeout(() => {
      loadingInstance.close();
    // }, 500);
    if (response.data.code && response.data.code != 0) {
      console.log(response);
      if (response.config.url == "/api/v1/YzdnUsers/alilogin") {
        // MessageBox.alert('获取用户信息失败，请重新登录！', '授权失败', {
        //   confirmButtonText: "跳转登录页面",
        //   callback: (item) => {
        //     window.location.href = '/'
        //   }
        // })
      } else {
        Message({
          showClose: true,
          message: response.data.msg,
          type: "error",
          offset: 80
        })
      }
    }
    if (response.data.code > 10000) {
      sessionStorage.removeItem("tokenData");
    }
    return response;
  },
  error => {
    // 请求失败
    if (error && error.response) {
      loadingInstance.close();
      switch (error.response.status) {
        case 400:
          // 对400错误您的处理\
          break;
        case 401:
          sessionStorage.removeItem("tokenData");
          MessageBox.alert('登录信息超时，请重新登录！', '登录超时', {
            confirmButtonText: "跳转登录页面",
            callback: (item) => {
              if (process.env.NODE_ENV == 'development') {
               window.location.href = '/'
              }else{
                // window.location.href = 'http://192.162.20.26:28088/web/'
                window.location.href = '/'
              }
            }
          })
          // vm.$router.push("/login");
          // 对 401 错误进行处理
          break;
        case 403:
          MessageBox.alert('您未有此权限,请联系管理员！', '未有此权限', {})
          // vm.$router.push("/login");
          // 对 401 错误进行处理
          break;
        default:
          // 如果以上都不是的处理
          return Promise.reject(error);
      }
    }
  }
);